var $ = require('lc-jquery');

module.exports = function(element, speed, pixelOffset) {
  var navHeight = 56;
  var secondaryNavHeight = navHeight;
  var scrollTop = $(document).scrollTop();
  var elementTop = element.offset().top;
  // account for fixed position secondary nav top
  pixelOffset = pixelOffset || secondaryNavHeight - 1;

  // if scrolling upward, add more offset for primary nav
  if (elementTop < scrollTop) {
    pixelOffset += navHeight;
  }

  // speed can be a number (in milliseconds).
  // jquery suggets 400 for normal,
  // 200 for fast, and 600 for slow
  speed = speed || 600;
  $('html, body').animate({
    scrollTop: elementTop - pixelOffset
  }, speed);
};

